<div class="asset-details-root">
  <div class="asset-details-header">
    <div class="row">
      <div class="asset-header-info col-6">
        <div class="header-info-column">
          <div class="header-title">
            <b>{{ 'POLES.EDIT.LT_SLRN' | translate }}</b>
          </div>
          <div class="header-info-line">
            <span class="light-gray-text">
              {{ selectedPole?.slrn ? selectedPole?.slrn : ('COMMON.NO_SLRN' | translate) }}
            </span>
            <span class="pill header-pill green-success-pill"
              *ngIf="disableUpdateStatusButton() && selectedPole.dataQualityStatus!.toString() == 'Approved'">
              {{ 'COMMON.ASSET_STATUS.COMPLETE' | translate }}
            </span>
            <span class="pill header-pill red-failure-pill"
              *ngIf="disableUpdateStatusButton() && selectedPole.dataQualityStatus!.toString() == 'Rejected'">
              {{ 'COMMON.ASSET_STATUS.REJECTED' | translate }}
            </span>
            <span class="pill header-pill" *ngIf="!disableUpdateStatusButton() && selectedPole.status"
              [ngClass]="{
                'light-gray-pill': selectedPole.status == 'Pending',
                'light-orange-pill': selectedPole.status == 'Assigned' || selectedPole.status == 'Retagged',
                'red-failure-pill': selectedPole.status == 'Rejected'
              }">
              {{ 'COMMON.ASSET_STATUS.' + selectedPole.status | uppercase | translate }}
            </span>
          </div>
        </div>
        <div class="header-info-column">
          <div class="light-gray-text">{{ selectedPole.address | hasValue }}</div>
          <div class="header-info-line light-gray-text">
            {{ selectedPole.postCode | hasValue }}
            <span class="pill asset-type-pill" *ngIf="selectedPole.poleType">
              {{ 'COMMON.POLE.TYPE.' + selectedPole.poleType | uppercase | translate }} {{ 'COMMON.TYPE' | translate | lowercase }}
            </span>
          </div>
        </div>
      </div>
      <div class="header-actions col">
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#poleHistory"
          *ngIf="selectedPole.poleHistories && selectedPole.poleHistories.length > 0">
          {{ 'COMMON.HISTORY' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Retagged);" data-bs-target="#assignToFieldAgent"
          *ngIf="permissionsService.isPoleRetagAllowed">
          {{ 'COMMON.RETAG' | translate }}
        </button>
        <div class="recall-container position-relative d-inline-block" *ngIf="
            permissionsService.isPoleRecallAssignedAllowed ||
            permissionsService.isPoleRecallValidatedAllowed
          ">
          <button class="btn asset-header-action-button" (click)="showRecallMenu = !showRecallMenu">
            {{ 'COMMON.RECALL' | translate }}
          </button>
          <div *ngIf="showRecallMenu" class="recall-options shadow-sm" @slideToggle>
            <div *ngIf="permissionsService.isPoleRecallAssignedAllowed" class="recall-type"
              [ngClass]="!recallAssignedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallAssignedAllowed ? recall() : null">
              <span>{{ 'COMMON.ASSIGNED_TASK' | translate }}</span>
            </div>
            <div *ngIf="permissionsService.isPoleRecallValidatedAllowed" class="recall-type"
              [ngClass]="!recallValidatedAllowed ? 'recall-type-disabled' : 'recall-type-enabled'"
              (click)="recallValidatedAllowed ? recall() : null">
              <span>{{ 'COMMON.VALIDATED_TASK' | translate }}</span>
            </div>
          </div>
        </div>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#updateStatus"
          [disabled]="disableUpdateStatusButton()" *ngIf="permissionsService.isPoleApproveRejectAllowed">
          {{ 'COMMON.UPDATE_STATUS' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#auditReview"
          [disabled]="disableAuditReviewButton()" *ngIf="permissionsService.isPoleAuditReviewAllowed">
          {{ 'COMMON.FIELD_AUDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#review"
          [disabled]="disableReviewButton()" *ngIf="permissionsService.isPoleReviewAllowed">
          {{ 'COMMON.REVIEW_BUTTON' | translate }}
        </button>
        <button class="btn asset-header-action-button" data-bs-toggle="modal" data-bs-target="#assignToFieldAgent"
          (click)="getMobileUsers(); setModalType(AssetAssignType.Assigned);" *ngIf="permissionsService.isPoleAssignAllowed">
          {{ 'COMMON.ASSIGN_AGENT' | translate }}
        </button>
        <button class="btn asset-header-action-button" *ngIf="!editEnabled && permissionsService.isPoleCreateEditAllowed"
          (click)="edit()">
          {{ 'COMMON.EDIT' | translate }}
        </button>
        <button class="btn asset-header-action-button asset-header-save-button" *ngIf="editEnabled"
          (click)="validateInput($event)">
          {{ 'COMMON.SAVE' | translate }}
        </button>
        <button class="btn btn-primary" #openUpdateDescriptionModal data-bs-toggle="modal" data-bs-target="#history"
          hidden></button>
      </div>
    </div>
  </div>

  <div class="asset-details-content">
    <div class="row">
      <!-- Column 1: pole info, connections -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12" [ngClass]="expanded.info ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'info', title: 'POLES.EDIT.LT_INFO' }"></ng-container>
          <div *ngIf="expanded.info" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.LT_ID' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.poleId | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.LT_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('PoleNumber')">{{ selectedPole.poleNumber | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('PoleNumber')" class="form-control" [(ngModel)]="selectedPole.poleNumber" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.ADD.TYPE_OF_POLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('PoleType')">{{ selectedPole.poleType | enumTranslate | translate }}</ng-container>
                <select *ngIf="isStaticEditable('PoleType')" class="form-control" [(ngModel)]="selectedPole.poleType">
                  <option *ngFor="let option of poleTypesOptions">
                    {{ option.value | translate }}
                  </option>
                </select>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.SHAPE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.poleShape | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.POLE.CONDITION.TITLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.poleCondition | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.NOTE' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <span *ngIf="!selectedPole.poleNotes.length">----</span>
                <span *ngFor="let note of selectedPole.poleNotes; let last = last">{{ note | enumTranslate | translate }}{{ last ? '' : ', ' }}</span>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.STRUCTURE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.poleStructure | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.CROSS_ARM' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.crossArm | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.CROSS_ARM_COND' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.crossArmCondition | enumTranslate | translate }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.STREET_LIGHT' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.streetLight | hasValue }}</div>
            </div>
            <ng-container *ngIf="selectedPole.streetLight === 'Yes'">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.STREET_LIGHT_SRC' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.streetLightSource | enumTranslate | translate }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.WATTAGE' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.wattage | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.STATE' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.state | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.ISOLATION' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.meansOfIsolation | hasValue }}</div>
              </div>
            </ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">
                <ng-container *ngIf="!isStaticEditable('Address')">{{ selectedPole.address | hasValue }}</ng-container>
                <input *ngIf="isStaticEditable('Address')" class="form-control" [(ngModel)]="selectedPole.address" />
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole.incomingACLineName : selectedPole.feederName) | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole.incomingACLineNumber : selectedPole.feederNumber) | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole?.substationName : selectedPole?.dtName) | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole?.substationNumber : selectedPole?.dtNumber) | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="selectedPole && selectedPole.upriserNames.length">
              <div class="col-5 asset-card-content-title">{{ (selectedPole.upriserNames.length > 1 ? 'COMMON.UPRISERS' : 'COMMON.UPRISER') | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.upriserNames.join(', ') | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.BU.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole?.geographicalRegionName : selectedPole?.region) | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.UT.SINGLE' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? selectedPole?.subGeographicalRegionName : selectedPole?.district) | hasValue }}</div>
            </div>
            <ng-container *ngIf="isGhanaPostFieldsVisible">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_GPS' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.postCode | hasValue }}</div>
              </div>
              <div class="asset-card-info row" *ngIf="selectedPole.postCodeException">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.GHANA_POST_GPS_EXC' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ selectedPole.postCodeException | hasValue }}</div>
              </div>
            </ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.COMMENT' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ selectedPole.comment | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.GEO_LOCATION' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.latitude }}, {{ selectedPole.longitude }}</div>
              <div class="geo-icon col-1" (click)="showPoleLocation()" data-bs-toggle="modal" data-bs-target="#showMap">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M8 0C8.30376 0 8.55479 0.225723 8.59452 0.518583L8.6 0.6L8.59925 2.03017C11.4343 2.31006 13.6899 4.56575 13.9706 7.40203L14 7.4H15.4C15.7314 7.4 16 7.66863 16 8C16 8.30376 15.7743 8.55479 15.4814 8.59452L15.4 8.6L13.9693 8.59923C13.6899 11.4343 11.4343 13.6899 8.59797 13.9706L8.6 14V15.4C8.6 15.7314 8.33137 16 8 16C7.69624 16 7.44521 15.7743 7.40548 15.4814L7.4 15.4L7.40077 13.9693C4.56575 13.6899 2.31006 11.4343 2.02942 8.59797L2 8.6H0.6C0.268629 8.6 0 8.33137 0 8C0 7.69624 0.225723 7.44521 0.518583 7.40548L0.6 7.4L2.03017 7.40075C2.31006 4.56575 4.56575 2.31006 7.40203 2.02942L7.4 2V0.6C7.4 0.268629 7.66863 0 8 0ZM8 3.2C5.34903 3.2 3.2 5.34903 3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2ZM8 4.8C9.76731 4.8 11.2 6.23269 11.2 8C11.2 9.76731 9.76731 11.2 8 11.2C6.23269 11.2 4.8 9.76731 4.8 8C4.8 6.23269 6.23269 4.8 8 4.8Z"
                    fill="var(--primary-color)" />
                </svg>
              </div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12" [ngClass]="expanded.connectedPoles ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'connectedPoles', title: 'POLES.EDIT.CONNECTED_POLES' }"></ng-container>
          <div *ngIf="expanded.connectedPoles" class="asset-card-content" @slideToggle>
            <ng-container [ngTemplateOutlet]="pager"
              [ngTemplateOutletContext]="{ current: countOfPoleSlrns ? currentPoleSlrnPage + 1 : 0, total: countOfPoleSlrns, pager: pagers.poles }"></ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.CONNECTED_POLE_SLRN' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentPoleSlrn | hasValue }}</div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12" *ngIf="countOfAdditionalDts != 0"
          [ngClass]="expanded.additionalDts ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'additionalDts', title: 'COMMON.ADDITIONAL_DTS' }"></ng-container>
          <div *ngIf="expanded.additionalDts && currentAdditionalDt" class="asset-card-content" @slideToggle>
            <ng-container [ngTemplateOutlet]="pager"
              [ngTemplateOutletContext]="{ current: currentAdditionalDtPage + 1, total: countOfAdditionalDts, pager: pagers.additionalDts }"></ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentAdditionalDt.feederName | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.FEEDER_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentAdditionalDt.feederNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentAdditionalDt.dtName | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NUMBER' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentAdditionalDt.dtNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row" *ngIf="currentAdditionalDt.upriserNames.length">
              <div class="col-5 asset-card-content-title">{{ (currentAdditionalDt.upriserNames.length > 1 ? 'COMMON.UPRISERS' : 'COMMON.UPRISER') | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentAdditionalDt.upriserNames.join(', ') | hasValue }}</div>
            </div>
          </div>
        </div>

        <div *ngIf="isDataQuality && selectedPole.dataValidationReview != null && selectedPole.dataValidationReview.length > 0"
          class="asset-card asset-card-expanded col-12">
          <div class="asset-card-header row">
            <h2 class="card-title asset-card-title col-12">{{ 'COMMON.DATA_VALID_REVIEW' | translate }}</h2>
          </div>
          <div class="asset-card-content">
            <div class="asset-card-info row" *ngFor="let dq of selectedPole.dataValidationReview">
              <div class="col-5 asset-card-content-title">{{ dq.key }}</div>
              <div *ngIf="dq.key != 'Reason for rejection'" class="col-7 asset-card-content-value">{{ dq.value | hasValue }}</div>
              <div *ngIf="dq.key == 'Reason for rejection'" class="col-7 asset-card-content-value">
                <a data-bs-toggle="modal" data-bs-target="#rejectionReason">{{ 'COMMON.VIEW' | translate | lowercase }}</a>
              </div>
            </div>
          </div>
        </div>

      </div>

      <!-- Column 2: buildings, user activity, images -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <div class="asset-card col-12" [ngClass]="expanded.connectedBuildings ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'connectedBuildings', title: 'POLES.EDIT.CONNECTED_BUILDINGS' }"></ng-container>
          <div *ngIf="expanded.connectedBuildings" class="asset-card-content" @slideToggle>
            <ng-container [ngTemplateOutlet]="pager"
              [ngTemplateOutletContext]="{ current: countOfBuilding ? currentBuildingPage + 1 : 0, total: countOfBuilding, pager: pagers.buildings }"></ng-container>
            <ng-container *ngIf="currentBuilding">
              <div class="asset-card-info row">
                <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.BUILDING_SLRN' | translate }}</div>
                <div class="col-7 asset-card-content-value">{{ currentBuilding?.slrn | hasValue }}</div>
              </div>
              <div class="asset-card-info row" *ngIf="!(hasCimDataIntegration ? currentBuilding.geographicalRegionName : currentBuilding.region)">
                <div class="col-12 alert alert-warning mb-0">{{ 'POLES.EDIT.BUILDING_NOT_TAGGED' | translate }}!</div>
              </div>
              <ng-container *ngIf="hasCimDataIntegration ? currentBuilding.geographicalRegionName : currentBuilding.region">
                <div class="asset-card-info row">
                  <div class="col-5 asset-card-content-title">{{ 'COMMON.BU.SINGLE' | translate }}</div>
                  <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? currentBuilding.geographicalRegionName : currentBuilding.region) | hasValue }}</div>
                </div>
                <div class="asset-card-info row">
                  <div class="col-5 asset-card-content-title">{{ 'COMMON.UT.SINGLE' | translate }}</div>
                  <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? currentBuilding.subGeographicalRegionName : currentBuilding.area) | hasValue }}</div>
                </div>
                <div class="asset-card-info row">
                  <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NAME' | translate }}</div>
                  <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? currentBuilding.substationName : currentBuilding.dtName) | hasValue }}</div>
                </div>
                <div class="asset-card-info row">
                  <div class="col-5 asset-card-content-title">{{ 'COMMON.DT_NUMBER' | translate }}</div>
                  <div class="col-7 asset-card-content-value">{{ (hasCimDataIntegration ? currentBuilding.substationNumber : currentBuilding.dtNumber) | hasValue }}</div>
                </div>
              </ng-container>
            </ng-container>
          </div>
        </div>

        <div class="asset-card col-12" *ngIf="currentBuilding && (hasCimDataIntegration ? currentBuilding.geographicalRegionName : currentBuilding.region)"
          [ngClass]="expanded.connectedCustomers ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'connectedCustomers', title: 'COMMON.MBC_DETAILS.CONNECTED_CUSTOMERS' }"></ng-container>
          <div *ngIf="expanded.connectedCustomers" class="asset-card-content" @slideToggle>
            <ng-container [ngTemplateOutlet]="pager"
              [ngTemplateOutletContext]="{ current: currentBuilding.connectedCustomers.length ? currentCustomerPage + 1 : 0, total: currentBuilding.connectedCustomers.length, pager: pagers.customers }"></ng-container>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentCustomer.name | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.CUSTOMER_ACC_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentCustomer.accountNumber | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.CUSTOMER_ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentCustomer.address | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'POLES.EDIT.CUSTOMER_PHYSICAL_ADDRESS' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentCustomer.physicalAddress | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.GEO_LOCATION' | translate }}</div>
              <div class="col-7 asset-card-content-value" *ngIf="currentBuilding.connectedCustomers.length !== 0">
                {{ currentBuilding.longitude }} , {{ currentBuilding.latitude }}
              </div>
              <div class="col-7 asset-card-content-value" *ngIf="currentBuilding.connectedCustomers.length === 0">
                {{ null | hasValue }}
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-5 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.METER_NO' | translate }}</div>
              <div class="col-7 asset-card-content-value">{{ currentCustomer.meterNumber | hasValue }}</div>
            </div>
          </div>
        </div>

        <div class="asset-card col-12" [ngClass]="expanded.userActivity ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'userActivity', title: 'MV_POLES.USER_ACTIVITY' }"></ng-container>
          <div *ngIf="expanded.userActivity" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.FIRST_CAPTURED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.firstCapturedUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.LAST_UPDATED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.lastUpdateUser | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.CREATION_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.creationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.UPDATED_DATE' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.lastUpdate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.reassignedBy | hasValue }}</div>
            </div>
            <div class="asset-card-info row">
              <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.ASSIGNED' | translate }}</div>
              <div class="col-6 asset-card-content-value">{{ selectedPole.assignedUser | hasValue }}</div>
            </div>
            <ng-container *ngIf="permissionsService.isValidationStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.VALIDATION_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">
                  <ng-container *ngIf="disableUpdateStatusButton() && selectedPole.dataQualityStatus!.toString() == 'Approved'">{{ 'COMMON.ASSET_STATUS.COMPLETE' | translate }}</ng-container>
                  <ng-container *ngIf="disableUpdateStatusButton() && selectedPole.dataQualityStatus!.toString() == 'Rejected'">{{ 'COMMON.ASSET_STATUS.REJECTED' | translate }}</ng-container>
                  <ng-container *ngIf="!disableUpdateStatusButton() && selectedPole.status">{{ selectedPole.status }}</ng-container>
                  <ng-container *ngIf="!disableUpdateStatusButton() && !selectedPole.status">--------</ng-container>
                </div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.validatedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.DATE_TYPE.VALIDATED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.validationDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isAuditStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.auditedStatus | enumTranslate | translate }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.AUDITED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.auditedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.AUDITED_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.auditedDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
              </div>
            </ng-container>
            <ng-container *ngIf="permissionsService.isReviewStatusAllowed">
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_STATUS' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.reviewStatus | enumTranslate | translate }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.USER.TYPE.REVIEWED' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.reviewedBy | hasValue }}</div>
              </div>
              <div class="asset-card-info row">
                <div class="col-6 asset-card-content-title">{{ 'COMMON.MBC_DETAILS.REVIEW_DATE' | translate }}</div>
                <div class="col-6 asset-card-content-value">{{ selectedPole.reviewDate | date:'dd/MM/yyyy HH:mm':'{{ timeZone }}' | hasValue }}</div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="asset-card col-12" [ngClass]="expanded.images ? 'asset-card-expanded' : 'asset-card-collapsed'">
          <ng-container [ngTemplateOutlet]="cardHeader"
            [ngTemplateOutletContext]="{ key: 'images', title: 'COMMON.IMAGES' }"></ng-container>
          <div *ngIf="expanded.images" class="asset-card-content" @slideToggle>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.LT_RIGHT_VIEW' | translate }}</div>
              <div class="col-12 images-list single-image-list">
                <app-image-section
                  [image]="getLTPoleRightImage()"
                  [index]="0"
                  [imageType]="ImageType.LTPoleRight"
                  [editEnabled]="isStaticEditable('LTPoleRightPicture')"
                  [inputId]="'fileLTPoleRight' + 0"
                  [permission]="permissionsService.isPoleCreateEditAllowed"
                  (imageClick)="showImage(ImageType.LTPoleRight)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.LT_LEFT_VIEW' | translate }}</div>
              <div class="col-12 images-list single-image-list">
                <app-image-section
                  [image]="getLTPoleLeftImage()"
                  [index]="0"
                  [imageType]="ImageType.LTPoleLeft"
                  [editEnabled]="isStaticEditable('LTPoleLeftPicture')"
                  [inputId]="'fileLTPoleLeft' + 0"
                  [permission]="permissionsService.isPoleCreateEditAllowed"
                  (imageClick)="showImage(ImageType.LTPoleLeft)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
            <div class="asset-card-info row">
              <div class="col-12 asset-card-content-title">{{ 'COMMON.PICTURES.MOUNTED_TAG' | translate }}</div>
              <div class="col-12 images-list single-image-list">
                <app-image-section
                  [image]="getBuildingMountedImage()"
                  [index]="0"
                  [imageType]="ImageType.MountedTag"
                  [editEnabled]="isStaticEditable('MountedTagPicture')"
                  [inputId]="'fileMountedTag' + 0"
                  [permission]="permissionsService.isPoleCreateEditAllowed"
                  (imageClick)="showImage(ImageType.MountedTag)"
                  (fileChange)="fileBrowserHandler($event)">
                </app-image-section>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Column 3: dynamic sections -->
      <div class="col-xl-4 col-md-6 d-flex flex-column gap-3">
        <lib-section-instance-card *ngFor="let section of sectionInstances" [section]="section"
          [editEnabled]="editEnabled" [editableAttributeIds]="editableAttributeIds" [editedValues]="editedValues"
          (mapClicked)="setClickedLocation($event)">
        </lib-section-instance-card>
      </div>
    </div>
  </div>
</div>

<ng-template #cardHeader let-key="key" let-title="title">
  <div class="asset-card-header row">
    <h2 class="card-title asset-card-title col-10">{{ title | translate }}</h2>
    <div class="collapse-arrow col-2">
      <button class="action-button" (click)="toggleCard(key)">
        <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path [attr.d]="$any(expanded)[key] ? 'M9 5L5 1L1 5' : 'M1 1L5 5L9 1'" stroke="#17171A"
            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #pager let-current="current" let-total="total" let-nav="pager">
  <div class="asset-card-info row pager-row">
    <div class="col-6 asset-card-content-title">{{ current }} / {{ total }}</div>
    <div class="col-6 pager-buttons">
      <button class="action-button" (click)="nav.prev()" [disabled]="total == 0">
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M5 1L1 5L5 9" stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
      <button class="action-button" (click)="nav.next()" [disabled]="total == 0">
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 1L5 5L1 9" stroke="#17171A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </div>
  </div>
</ng-template>

<div class="modal fade" id="assignToFieldAgent" tabindex="-1" aria-hidden="true"
  (hidden.bs.modal)="onModalAssignFade()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 *ngIf="assetAssignType == AssetAssignType.Assigned" class="modal-title">{{'COMMON.ASSIGN_AGENT' | translate}}</h5>
        <h5 *ngIf="assetAssignType == AssetAssignType.Retagged" class="modal-title">{{'COMMON.RETAG_TASK' | translate}}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="modal-body">
        <div class="form-floating form-item">
          <input #userFilterInput autocomplete="off" type="text" name="filterText" [(ngModel)]="filterText"
            class="form-control filter-field" [ngClass]="{ 'valid-input': tempAssignedUserId != 0 }" id="floatingInput"
            (ngModelChange)="filterMobileUsers()" (click)="openDropdown()" placeholder=" " />
          <label for="floatingInput">{{'COMMON.FIELD_AGENT' | translate}}</label>

          <div class="filtered-agent-list" *ngIf="isDropdownOpened" #dropdownContainer>
            <div click-stop-propagation class="agent-name" (click)="selectFieldAgent(u.id)"
              *ngFor="let u of mobileUsers">
              {{ u.fullName }}
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" (click)="assignTask()">
          <span *ngIf="assetAssignType == AssetAssignType.Assigned">{{'COMMON.ASSIGN_TASK' | translate}}</span>
          <span *ngIf="assetAssignType == AssetAssignType.Retagged">{{'COMMON.RETAG_TASK' | translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showImageMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isImageMapVisible" [longitude]="selectedImage?.longitude"
          [latitude]="selectedImage?.latitude"></app-building-map>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="modalImage" tabindex="-1" aria-hidden="true" (hidden.bs.modal)="onModalFade()"
  (shown.bs.modal)="onModalOpen()">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content modal-image">
      <div class="modal-body modal-body-image">
        <div class="image-container" [style.transform]="'rotate(' + currentRotation + 'deg)'">
          <lib-ngx-image-zoom [zoomMode]="'hover-freeze'" [fullImage]="selectedImage?.url" [thumbImage]="selectedImage?.url"
            [magnification]="3">
          </lib-ngx-image-zoom>
        </div>
        <div class="rotate-div">
          <button class="btn btn-primary left-button" (click)="rotateLeft()">
            &lt;
          </button>
          <button class="btn btn-primary right-button" (click)="rotateRight()">
            &gt;
          </button>
        </div>
        <app-image-geo-info [image]="selectedImage"
          (mapClicked)="isImageMapVisible = !isImageMapVisible"></app-image-geo-info>
      </div>
    </div>
  </div>
</div>

<div class="modal modalMap" id="showMap" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" #closeAddModal class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <app-building-map [setMapVisibility]="isMapVisible" [longitude]="longitude" [latitude]="latitude">
        </app-building-map>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="updateStatus" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.DATA_VALID_REVIEW' | translate}}</h5>
        <button type="button" #closeModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <div class="modal-body">
        <app-data-quality assetType="Pole" [assetId]="selectedPole.id"
          [areaId]="selectedPole.districtId"></app-data-quality>
      </div>
    </div>
  </div>
</div>
<div class="modal" id="auditReview" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.FIELD_AUDIT' | translate}}</h5>
        <button type="button" #closeAudit class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <app-audit-review (closeModal)="cancel()" assetType="Pole" [assetId]="selectedPole.id"
        [areaId]="selectedPole.districtId"></app-audit-review>
    </div>
  </div>
</div>
<div class="modal" id="review" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.REVIEW' | translate}}</h5>
        <button type="button" #closeReviewModal class="btn-cancel-modal" data-bs-dismiss="modal" aria-label="Close">
          {{'COMMON.CANCEL' | translate}}
        </button>
      </div>
      <app-review (closeModal)="cancelReviewModal($event)" assetType="Pole"
        [assetId]="selectedPole.id"></app-review>
    </div>
  </div>
</div>
<app-history (update)="updateHistory($event)"></app-history>

<div class="modal fade" id="poleHistory" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered history-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'COMMON.HISTORY' | translate }}</h5>
        <button type="button" class="btn-cancel-modal" data-bs-dismiss="modal">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
      </div>
      <app-history-tracker [histories]="selectedPole.poleHistories"></app-history-tracker>
    </div>
  </div>
</div>

<div class="modal" id="rejectionReason" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'COMMON.REASON_FOR_REJECT' | translate}}</h5>
      </div>
      <div class="p-4">
        {{ modalRejectionReason }}
      </div>
      <button type="button" #closeRejectionReason class="btn btn-primary w-50 mx-auto"  data-bs-dismiss="modal" aria-label="Close">
        {{'COMMON.CLOSE' | translate}}
      </button>
    </div>
  </div>
</div>
